import US_STATES from "@/constants/US_STATES";
import ADMIN_CONSOLE_ROUTE_CONTENTS from "../constants/AdminConsoleRouteContents";
import ADMIN_CONSOLE_ROUTES from "../constants/AdminConsoleRoutes";

export const BREADCRUMB = {
  href: ADMIN_CONSOLE_ROUTES.SCHOOLS,
  contents: ADMIN_CONSOLE_ROUTE_CONTENTS.SCHOOLS,
};

export const SCHOOL_INITIAL_STATE = {
  schoolId: "",
  schoolName: "",
  schoolSource: "Newsela",
  schoolGeneralInformation: {
    schoolName: {
      value: "",
      editable: true,
    },
    parentDistrict: {
      value: "",
      editable: true,
    },
    streetAddress: {
      value: "",
      editable: true,
    },
    suite: {
      value: "",
      editable: true,
    },
    city: {
      value: "",
      editable: true,
    },
    state: {
      value: "",
      editable: true,
    },
    zip: {
      value: "",
      editable: true,
    },
    website: {
      value: "",
      editable: true,
    },
    emailDomains: {
      value: [
        {
          domain: "",
          // TODO: define how domain id should be set to add a new school domain.
        },
      ],
      editable: true,
    },
    status: {
      value: null,
      editable: true,
    },
  },
  schoolAdditionalInformation: {
    licenses: [],
    timezone: null,
    classrooms: [],
    teachers: [],
    students: [],
  },
  classes: [],
  students: [],
  teachers: [],
};

export const US_STATE_FULL_VALUE = (code) =>
  US_STATES.find(({ abbreviation }) => abbreviation === code);

export const mapEditableInitialState = (userCanEdit) => {
  const initialState = SCHOOL_INITIAL_STATE;
  Object.keys(initialState.schoolGeneralInformation).forEach((key) => {
    initialState.schoolGeneralInformation[key] = {
      value: initialState.schoolGeneralInformation[key].value,
      editable: key === "status" ? false : userCanEdit,
    };
  });
  return initialState;
};

export const getSchoolName = ({ name, id }) => name || `Unnamed school: ${id}`;
